import React, { useEffect, useState } from "react";
import CommonTitle from "../../../../components/CommonTitle";
import blocksImg from "../../../../assets/icons/block.webp";
import SeasonBlockCard from "../../../../components/season/SeasonBlockCard";
import {
  createSeasonBlock,
  getSeasonBlocksById,
  getSeasonBlocksBySeasonNumber,
  relateBlockToSeason,
} from "../../../../services/seasons";
import { getSupplies } from "../../../../services/medicines";
import { useNavigate, useParams } from "react-router-dom";
import LoadingPage from "../../../../components/LoadingPage";
import { MdAdd } from "react-icons/md";
import { nextLetter } from "../../../../utils/blockFuncs";
import ModalStructure from "../../../../components/ModalStructure";
import { IS_LOCAL_ENV } from "../../../../App";
import Notification from "../../../../components/ui-elements/Notification";

const SeasonBlocks = ({ seasonId }) => {
  /*Aqui se cargan los bloques asociados a una temporada.
  Por default, son 4 bloques: A, B, C, D, pero también se pueden agregar otros.
  Cada bloque tiene una lista de medicinas asociadas, que también puede modificarse.
  
  el intervalo del bloque, y la fecha de inicio y fin, se definen en otro screen*/

  const [loading, setLoading] = useState(true); //mostrar cargando mientras se trae la data del back
  const [blocks, setBlocks] = useState([]); //arreglo de objetos Bloque
  const [supplies, setSupplies] = useState([]); //arreglo de medicinas disponibles
  const [_seasonId, setSeasonId] = useState(seasonId || null); // id de la temporada.
  const [seasonInitDate, setSeasonInitDate] = useState(null);
  const [seasonEndDate, setSeasonEndDate] = useState(null);
  //en caso no sea seteado como prop, se buscan los bloques de la temporada por el numero de temporada de la url
  //el numero de temporada es único y creciente
  const { seasonNumber } = useParams(); //numero de temporada
  const [creating, setCreating] = useState(false);
  const [blockLetters, setBlockLetters] = useState([]);
  const [blockIds, setBlockIds] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  //===================fetch data =====================
  useEffect(() => {
    const fetchBlocksAndSupplies = async () => {
      //carga de bloques de temporada, y lista de medicinas
      try {
        //aqui se evalua si se recibe el id de temporada como prop
        const response = _seasonId
          ? await getSeasonBlocksById(_seasonId) //buscar por id de temporada
          : await getSeasonBlocksBySeasonNumber(seasonNumber); //buscar por numero de temporadas
        const response2 = await getSupplies(); //traer lista de medicinas/alimentos (supplies)
        IS_LOCAL_ENV && console.log("blocksInfo:", response);
        setSupplies(response2.docs); //
        //IS_LOCAL_ENV && console.log(response, response2.docs); //array de bloques
        setSeasonId(response[0].season.id);
        setSeasonInitDate(response[0].season.initDate);
        setSeasonEndDate(response[0].season.endDate);
        setBlocks(response);
        //IS_LOCAL_ENV && console.log(response);
      } catch (err) {
        IS_LOCAL_ENV && console.error(err);
      }
    };
    fetchBlocksAndSupplies();
  }, []);

  useEffect(() => {
    if (blocks.length > 0) {
      //para crear nuevos bloques, necesito la siguiente letra
      //necesito la lista de letras de los bloques de la temporada para saber que
      let bl = blocks.map((block) => block.letter);
      setBlockLetters(bl);
      //para relacionar un bloque nuevo a la temporada, necesito la lista de id's de todos los bloques relacionados a esa temporada, luego simplemente se concatena el id con axios.patch
      let bi = blocks.map((block) => block.id);
      setBlockIds(bi);
      IS_LOCAL_ENV && console.log("ids de bloques: ", bi);
      setLoading(false); //finalizar carga
    }
  }, [blocks]);
  //=======================handle add block=============================
  const onClickAddBlock = () => {
    const handleAddBlock = async () => {
      try {
        setCreating(true); //estado en actualizando...
        const nextl = nextLetter(blockLetters); //obtener siguiente letra
        let tl = [...blockLetters, nextl];
        setBlockLetters(tl); //actualizar letras de bloques
        const props = {
          name: `Bloque ${nextl}`,
          letter: nextl,
          season: _seasonId,
          initDate: seasonInitDate,
          endDate: seasonEndDate,
          supplies: [],
        };
        const newBlock = await createSeasonBlock(props);
        IS_LOCAL_ENV && console.log("nuevo bloque creado: ", newBlock);
        const res = await relateBlockToSeason(_seasonId, blockIds, newBlock.id);
        IS_LOCAL_ENV && console.log(res);
        let newBlocks = [...blocks, newBlock];
        setBlocks(newBlocks);
        setShowModal(false);
        Notification({
          title: "Operación completada",
          text: `Se crepó un nuevo bloque`,
          type: "Success",
        });
        setCreating(false); //finalizó la actualización
      } catch (err) {
        setCreating(false);
        IS_LOCAL_ENV && console.error(err);
      }
    };
    handleAddBlock();
  };
  //=======================================================================
  const updateBlockSupplies = (pos, info) => {
    const temp = [...blocks];
    temp[pos].supplies = info;
    setBlocks(temp);
  };
  //=======================================================================

  return (
    <>
      <div className="flex flex-col w-full h-full">
        <CommonTitle
          img={blocksImg}
          title={"Bloques"}
          text={
            "Haz seguimiento de los sistemas que existen en cada bloque para una buena administración de los medicamentos."
          }
        />
        {loading ? (
          <LoadingPage />
        ) : (
          <div className="w-full flex flex-col items-center justify-center">
            <div className="flex flex-wrap max-w-[1280px] w-full justify-center py-6">
              {blocks.map((block, i) => {
                return (
                  <SeasonBlockCard
                    supplies={supplies}
                    key={i}
                    _blockInfo={block}
                    blockPos={i}
                    updateParentInfo={updateBlockSupplies}
                    seasonStatus={blocks[0].season.status}
                  />
                );
              })}
            </div>
            {showModal && (
              <ModalStructure
                handleCloseModal={() => setShowModal(false)}
                customMaxW={"max-w-[350px]"}
              >
                <div className="flex flex-col items-center justify-center gap-y-4 my-2 font-poppins">
                  <h3 className="font-poppins font-bold text-dark-green text-wrap text-lg">
                    Crear bloque
                  </h3>
                  <span className="text-default-gray w-full text-center px-4 flex">
                    Esto puede aumentar el consumo de medicinas
                  </span>
                  <button
                    className={` w-fit  text-lg flex justify-center rounded-full py-2 px-4 text-white  ${
                      creating
                        ? "bg-default-gray cursor-not-allowed"
                        : "bg-light-purple-600 hover:bg-dark-purple"
                    }   transition-all duration-100 font-bold font-poppins `}
                    onClick={onClickAddBlock}
                  >
                    <span className="flex flex-row items-center gap-x-2">
                      <span>
                        {creating ? "Creando bloque..." : "Añadir bloque"}
                      </span>
                      <MdAdd />
                    </span>
                  </button>
                </div>
              </ModalStructure>
            )}
            {blocks[0].season.status == "hidden" && (
              <button
                className={` w-fit mb-4 text-xl  flex justify-center rounded-full py-4 px-8 text-white  ${
                  creating
                    ? "bg-default-gray cursor-not-allowed"
                    : "bg-light-purple-600 hover:bg-dark-purple"
                }   transition-all duration-100 font-bold font-poppins `}
                onClick={() => {
                  setShowModal(true);
                }}
              >
                <span className="flex flex-row items-center gap-x-2">
                  <span>
                    {creating ? "Creando bloque..." : "Añadir bloque"}
                  </span>
                  <MdAdd />
                </span>
              </button>
            )}
            {blocks[0].season.status != "hidden" && (
              <button
                className={` w-fit  text-xl mb-6 flex justify-center rounded-full py-4 px-8 text-white bg-light-purple-600 hover:bg-dark-purple transition-all duration-100 font-bold font-poppins `}
                onClick={() =>
                  navigate(
                    `/home/temporadas/${blocks[0].season.number}/programa`
                  )
                }
              >
                <span className="flex flex-row items-center gap-x-2">
                  <span>Ver programa de riego</span>
                </span>
              </button>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default SeasonBlocks;
